import axios from 'axios'
import SETTINGS from '../settings'

const url = SETTINGS.APIURL;

console.log(process.env);

const http = axios.create({
    baseURL: url
    /* other custom settings */
})

http.interceptors.request.use(
    (config) => {
        let token = window.$msal.accessToken;
        if (token) { config.headers.Authorization = `Bearer ${token}` }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * Whenever error.message is accessed we want to se the full API error message (JSON) if it's present
 * not just some generic http status code + message
 * see https://github.com/axios/axios/issues/960 for context
 */
http.interceptors.response.use(undefined, function (error) {
    error.originalMessage = error.message;
    Object.defineProperty(error, "message", {
        get: function () {
            if (!error.response) {
                return error.originalMessage;
            }
            return JSON.stringify(error.response.data);
        }
    });
    return Promise.reject(error);
})

export default http;

